<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="过期天数：">
                <input class="input-defind" v-model="searchForm.remainExpireDate" 
                @keyup="formatDate()" 
                @blur="formatDate()" 
                placeholder="请输入过期天数"
                clearable>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierId" clearable>
                    <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentPathId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentPathId" :key="item.agentPathId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>
              <el-form-item label="流量月份：">
                     <el-date-picker v-model="searchForm.countMonth" type="month" placeholder="选择结算月份" value-format="yyyy-MM"></el-date-picker>
                 </el-form-item>
                 
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminExpireSimListHandle">搜索查询</el-button>
                <el-button type="success"  @click="exportAdminEndTimeSimHandle">导出Excel</el-button>
                <!-- <el-button type="success"  @click="exportAdminEndTimeSimHandle1">导出六个月使用量</el-button> -->
                 <el-button type="success"  @click="exportAdminEndTimeSimHandle12">导出十二个月使用量</el-button>

                  <el-button type="success"  @click="exportSimMonthData">导出月使用量</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号码" width="130px"></el-table-column>
            <el-table-column prop="remainsDay" label="剩余天数 " width="80px"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" width="130px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="agentName" label="所属代理商" show-overflow-tooltip></el-table-column>
            <el-table-column prop="agentPathName" label="代理商层级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="importNum" label="导入批次" width="80px"></el-table-column>
            <el-table-column prop="activationrTime" label="激活时间" width="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="expireTime" label="到期时间" width="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalFlow" label="总流量(M)" width="80px"></el-table-column>
            <el-table-column prop="useFlow" label="已使用流量(M)" width="100px"> </el-table-column>
            <el-table-column prop="remainsFlow" label="剩余流量(M)" width="100px"></el-table-column>
            <el-table-column prop="stateName" label="卡状态"  width="80px"></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>        
    </div>
</template>

<script>
import {getAdminExpireSimList, exportSimInfo} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            agentsOption: [],
            supplierOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            }            
        }
    },
    methods: {
        cancel(){
            this.simHandleVisibale = false;    
            this.$refs.simHandleForm.resetFields();  
        },
        getAdminExpireSimListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAdminExpireSimList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'endTimeMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        exportAdminEndTimeSimHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
             common.sysRequest('/excels/admin/expire/sim/all', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })     
        },
         exportAdminEndTimeSimHandle1(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
             common.sysRequest('/excels/admin/expire/sim/all/six/data', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })     
        },
        exportSimMonthData(){
         var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
             common.sysRequest('/excels/admin/expire/sim/month/data', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })     
        },
        exportAdminEndTimeSimHandle12(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
             common.sysRequest('/excels/admin/expire/sim/all/year/data', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载中心查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })     
        },
        formatDate(){
            this.searchForm.remainExpireDate = this.searchForm.remainExpireDate.replace(/\D/g,'');
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminExpireSimListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminExpireSimListHandle();
        }       
    },
    created () {
        this.getAdminExpireSimListHandle();
        common.getSupplierOptsCom(this, 'supplierOption')
          common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        });
    }
}
</script>

<style lang="scss" scoped>

    .input-defind{
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }

</style>

